// @ts-strict-ignore
import {Component, Input} from "@angular/core";
import {PlayerMapping, ScenarioRecording, ScenarioRecordingMessageType} from "@models";
import {EventEmitterService} from "@event-emitter";
import {SimRecordingsService} from "@services";
import {Translations} from "@translations";

@Component({
	selector: "sim-clinical-vignette",
	templateUrl: "./clinical-vignette.component.html",
	styleUrls: ["./clinical-vignette.component.scss"],
	providers: [EventEmitterService],
	standalone: false,
})
export class ClinicalVignetteComponent {
	T = Translations;

	@Input() public playerInfo: PlayerMapping;
	@Input() public scenarioRecording: ScenarioRecording;

	constructor(
		private _eventEmitterService: EventEmitterService,
		private _simRecordingsService: SimRecordingsService,
	) {}

	public get getFontSize() {
		return ((this.scenarioRecording?.message?.fontSize ? this.scenarioRecording?.message?.fontSize : 100) * 2) / 100;
	}

	public get getFontSizeHeader() {
		return ((this.scenarioRecording?.message?.fontSize ? this.scenarioRecording?.message?.fontSize : 100) * 3) / 100;
	}

	public get getClinicalVignetteText() {
		return this.scenarioRecording?.message?.body ?? this.getDefaultMessageBody() ?? "No Description";
	}

	getDefaultMessageBody() {
		switch (this.scenarioRecording?.message?.type) {
			case ScenarioRecordingMessageType.ScenarioDescription:
				return this.scenarioRecording?.scenario?.caseDescription;
			case ScenarioRecordingMessageType.ClinicalVignette:
				return this.scenarioRecording?.scenario?.clinicalVignetteText;
			case ScenarioRecordingMessageType.ScenarioCaseSummary:
				return this.scenarioRecording?.scenario?.caseDescription;
			default:
				return "";
		}
	}

	getClinicalVignetteTextHeader() {
		return this.scenarioRecording?.message?.headline;
	}
}
